import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { MSG_TYPE_CREATE_COMMENT_IN_CACHE, MSG_TYPE_DELETE_COMMENT_SUCCESS, MSG_TYPE_EMBEDDED_COMMENT, MSG_TYPE_REMOVE_EMBEDDED_COMMENT } from 'collaboration-sidebar/constants/IFrameMessageTypes';
import COMMENT_TYPES from 'collaboration-sidebar/constants/CommentTypes';
export default function useCommentIndicatorsSync(t0) {
  "use memo";

  const $ = _c(6);
  const {
    setModuleReply,
    removeModuleReply,
    incrementReplyCountBy
  } = t0;
  let t1;
  if ($[0] !== incrementReplyCountBy || $[1] !== removeModuleReply || $[2] !== setModuleReply) {
    t1 = t2 => {
      const {
        payload
      } = t2;
      bb2: switch (payload.type) {
        case MSG_TYPE_EMBEDDED_COMMENT:
          {
            var _payload$comment;
            setModuleReply(payload.moduleId, (_payload$comment = payload.comment) !== null && _payload$comment !== void 0 ? _payload$comment : null);
            break bb2;
          }
        case MSG_TYPE_REMOVE_EMBEDDED_COMMENT:
          {
            const broadcastPayload = payload.payload;
            removeModuleReply(broadcastPayload.moduleId);
            break bb2;
          }
        case MSG_TYPE_DELETE_COMMENT_SUCCESS:
          {
            incrementReplyCountBy(payload.parentCommentId, -1);
            break bb2;
          }
        case MSG_TYPE_CREATE_COMMENT_IN_CACHE:
          {
            const comment = payload.payload.commentData;
            if (comment.type === COMMENT_TYPES.REPLY) {
              incrementReplyCountBy(comment.parentId, 1);
            }
            break bb2;
          }
        default:
      }
    };
    $[0] = incrementReplyCountBy;
    $[1] = removeModuleReply;
    $[2] = setModuleReply;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleMessage = t1;
  let t2;
  if ($[4] !== handleMessage) {
    t2 = {
      handleMessage
    };
    $[4] = handleMessage;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}